import { Trash2, Lock } from "lucide-react";

const CURRENCIES = ["CHF", "EUR", "USD"];

export function ServiceItemRow({ item, index, onChange, onRemove }) {
  const structured = item.kind === "structured";
  const set = (patch) => onChange(index, { ...item, ...patch });
  return (
    <div
      className="border border-slate-200 rounded-md px-4 py-3 bg-white hover:border-slate-300 transition-colors"
      data-testid={`gbp-service-row-${index}`}
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 min-w-0 space-y-2">
          <div className="flex items-center gap-2 flex-wrap">
            {structured ? (
              <span className="inline-flex items-center gap-1 text-sm font-semibold text-slate-900" data-testid={`gbp-service-name-${index}`}>
                <Lock className="w-3 h-3 text-slate-400" /> {item.display_name}
              </span>
            ) : (
              <input
                value={item.display_name || ""}
                onChange={(e) => set({ display_name: e.target.value })}
                maxLength={140}
                placeholder="Nom du service (ex. Location de voitures longue durée)"
                data-testid={`gbp-service-name-${index}`}
                className="flex-1 min-w-[220px] text-sm font-semibold text-slate-900 border-b border-transparent focus:border-[#002FA7] focus:outline-none bg-transparent py-0.5"
              />
            )}
            <span
              className={`text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded ${
                structured ? "bg-slate-100 text-slate-600" : "bg-blue-50 text-[#002FA7]"
              }`}
              data-testid={`gbp-service-kind-${index}`}
            >
              {structured ? "Prédéfini Google" : "Personnalisé"}
            </span>
          </div>
          <textarea
            value={item.description || ""}
            onChange={(e) => set({ description: e.target.value })}
            maxLength={structured ? 300 : 250}
            rows={2}
            placeholder="Description courte (bénéfice client, zone desservie)…"
            data-testid={`gbp-service-desc-${index}`}
            className="w-full text-xs text-slate-700 border border-slate-200 rounded px-2 py-1.5 focus:outline-none focus:border-[#002FA7] resize-none"
          />
          <div className="flex items-center gap-2 text-xs text-slate-600">
            <span>Prix</span>
            <input
              type="number"
              min="0"
              step="0.05"
              value={item.price_amount ?? ""}
              onChange={(e) => set({ price_amount: e.target.value === "" ? null : Number(e.target.value) })}
              placeholder="—"
              data-testid={`gbp-service-price-${index}`}
              className="w-24 border border-slate-200 rounded px-2 py-1 focus:outline-none focus:border-[#002FA7]"
            />
            <select
              value={item.price_currency || "CHF"}
              onChange={(e) => set({ price_currency: e.target.value })}
              data-testid={`gbp-service-currency-${index}`}
              className="border border-slate-200 rounded px-1.5 py-1 bg-white"
            >
              {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
            <span className="text-slate-400">· laissez vide pour « sur devis »</span>
            <span className="ml-auto text-slate-400">{(item.description || "").length}/{structured ? 300 : 250}</span>
          </div>
        </div>
        <button
          onClick={() => onRemove(index)}
          title="Retirer ce service"
          data-testid={`gbp-service-remove-${index}`}
          className="text-slate-400 hover:text-red-600 p-1 rounded transition-colors"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
